<template>
  <div class="operation-options ml-auto flex space-x-4">
    <TransactionOptionsItem v-for="(option,i) in availableOptions"
                            :key="i"
                            @click="$emit('toggleOption',option)"
                            :active="optionsList[option]"
                            :option="option"/>
  </div>
</template>

<script>
import TransactionOptionsItem from "@/components/common/Transaction/TransactionOptions/TransactionOptionsItem";

export default {
  name: "TransactionOptions",
  components: {TransactionOptionsItem},
  props: {
    operation: {
      type: Number,
      required: true
    },
    optionsList: {
      type: Object,
      required: true
    },
    transactionIsInPast: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    availableOptions() {
      const defaultOptions = ['comment', 'tags'],
          transferMoreOptions = ['category'],
          calendarAvailableOptions = ['calendar'],
          agentAvailableOptions = ['agent'];

      let options = [...defaultOptions];

      if (this.operation === 3) {
        options = [...options, ...transferMoreOptions]
      } else {
        if (!this.transactionIsInPast) options = [...options, ...calendarAvailableOptions]
        if (this.$store.getters['space/spaceUseContractors']) options = [...agentAvailableOptions, ...options]
      }
      return options;
    }
  },
}
</script>